export const environment = {
  production: true,
  apiUrl: "https://api.coolecontent.com/api/v1/",
  mediaUrl: "https://cdn.coolecontent.com/media/images/",
  websiteUrl: "https://coolecontent.com/",
  domain: "Chappa",
  revalidationSecretToken: "MfFsAzs3IGDfFtBIvrBw7S5pclMLXwskATPGzA5LHE5FhBWlaG",
  staging: false,
};
